import { Box, Typography } from '@material-ui/core';
import React, { FunctionComponent, ReactElement, useMemo } from 'react';
import { IPrice } from '../../../../../../../../common/model/IPrice';
import PriceWithLabel from '../../../../customiseContainer/footer/PriceSection/CarPrices/PriceWithLabel/PriceWithLabel';
import IndicativeNumber from '../../../../../../common/components/indicativeNumber/IndicativeNumber';
import singleCurrencyCashStyles from './singleCurrencyCashStyles';
import Translation from '../../../../../../common/components/translation/Translation';

export interface IMultiCarPricesCash {
  primaryPrice: IPrice;
  secondaryPrice?: IPrice;
  isCash: boolean;
  hasTradeIn: boolean;
  loading?: boolean;
  onIndicativeClick: () => void;
}

const SingleCurrencyCash: FunctionComponent<IMultiCarPricesCash> = ({
  primaryPrice,
  hasTradeIn,
  loading,
  onIndicativeClick,
}) => {
  const styles = singleCurrencyCashStyles();
  const cashPriceLabel: ReactElement = useMemo(() => {
    return (
      <Translation
        id={
          hasTradeIn
            ? `spc.customise.prices.label.totalWithTradeIn`
            : 'spc.customise.prices.label.vehicleTotalPriceSticky'
        }
      />
    );
  }, [hasTradeIn]);

  const indicativeNumber: ReactElement = useMemo(() => {
    if (hasTradeIn) {
      return null;
    }

    return (
      <IndicativeNumber
        dataTest="vehicle_total_price"
        displayNumber={<Translation id="spc.customise.indicative.vehicleTotalPrice" />}
        onClick={onIndicativeClick}
      />
    );
  }, [hasTradeIn]);

  return (
    <Box className={styles.price} display="flex" alignItems="center" data-test={'car_prices:cash:vehicle_total_price'}>
      <PriceWithLabel
        price={primaryPrice}
        loading={loading}
        label={
          <Box
            display="flex"
            data-test="customise:footer:vehicle_total_price"
            justifyContent="center"
            lineHeight="normal"
            textAlign="center"
          >
            <Typography className={styles.priceLabel}>
              {cashPriceLabel}
              {indicativeNumber}
            </Typography>
          </Box>
        }
      />
    </Box>
  );
};

export default SingleCurrencyCash;
